import { useState } from "react";
import * as React from "react";

import { WEIGHT_BOLD } from "@hl/base-components/lib/theme/typography";
import {
  FEATURE_FLAGS,
  useFeatureFlags,
} from "@hl/shared-features/lib/features/auth/hooks";
import { Anchor, Text, Group } from "@mantine/core";

import { EditDetails } from "~/features/tokens/sections/ManageToken/modals/EditDetails/EditDetails";
import { GetManageTokenCollectionQuery } from "~/features/tokens/sections/ManageToken/queries.graphql.generated";

import { PropertyBox } from "./PropertyBox";

export const NameProperty = ({
  name,
  collection,
  refetch,
}: {
  name: string;
  collection: GetManageTokenCollectionQuery["getCollection"];
  refetch?: () => void;
}) => {
  const [showEditModal, setShowEditModal] = useState<boolean>(false);
  const enableEdit = useFeatureFlags(
    FEATURE_FLAGS.ENABLE_EDIT_COLLECTION_DETAILS
  );
  return (
    <>
      <PropertyBox
        label="Name"
        value={
          <Group position="apart" w="100%">
            <Text size="sm">{name}</Text>
            {enableEdit && (
              <Anchor
                w="auto"
                underline={false}
                onClick={() => setShowEditModal(true)}
              >
                <Text size="sm" fw={WEIGHT_BOLD}>
                  Edit
                </Text>
              </Anchor>
            )}
          </Group>
        }
      />
      <EditDetails
        collection={collection}
        isOpened={showEditModal}
        onClose={() => setShowEditModal(false)}
        refetch={refetch}
      />
    </>
  );
};
